<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <div class="panel panel-body">
          <div class="col-xs-12 col-sm-12 search">
            <input
              v-model="queryString"
              name="query_string"
              type="text"
              class="search-field"
              :placeholder="trans('core.search')"
              @keyup.enter="getResults"
            >
            <a
              href="#"
              class="btn btn-default"
              @click="getResults"
            >{{ trans('core.search') }}</a>
          </div>
          <div
            v-for="filter in filters"
            :class="filterColumns"
          >
            <h4>{{ filter.name }}</h4>
            <div
              v-for="filterItem in filter.values"
              v-if="filterItem.visible"
            >
              <filter-component
                :filter="filterItem"
                @inputUpdated="updateFilter"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="panel panel-body">
          <h4>{{ trans_choice('core.results', 2) }}</h4>

          <vue-good-table
            mode="remote"
            :pagination-options="{
              enabled:true,
              dropdownAllowAll: false,
              nextLabel: trans('core.next'),
              prevLabel: trans('core.previous'),
              rowsPerPageLabel: trans('datatables.rows_per_page'),
              ofLabel: trans('datatables.of_page'),
            }"
            :total-rows="totalRecords"
            :columns="columns"
            :rows="rows"
            style-class="vgt-table condensed striped"
            :is-loading="loading"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            @on-per-page-change="onPerPageChange"
          >
            <!-- adds url to the name row-->
            <template
              slot="table-row"
              slot-scope="props"
            >
              <span v-if="props.column.field == 'name'">
                <a
                  :href="props.row.url"
                  v-safe-html="format(props.row.name)"
                />
                <p
                  v-if="props.row.description != ''"
                  v-safe-html="format(props.row.description)"
                />
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>

            <template slot="emptystate">
              <div class="text-center">
                <span v-safe-html="trans('datatables.no_records')" />
              </div>
            </template>

            <template slot="loadingContent">
              <div class="loading-data">
                <i class="fa fa-spinner fa-pulse fa-fw" /> <span v-safe-html="trans('core.loading')" />
              </div>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import FilterComponent from './FilterComponent'
import axios from 'axios'
import { VueGoodTable } from 'vue-good-table'
import { defaultErrorMessage, escapeRegExp } from '../../helpers'

export default {
  name: 'SearchComponent',
  components: {
    FilterComponent,
    VueGoodTable,
  },
  props: {
    filterOptions: null,
    startQuery: null,
    programId: {
      required: true,
    },
  },
  data () {
    return {
      filters: null,
      queryString: null,
      highlightString: null,
      newResults: null,
      filterValues: {},
      loading: false,

      totalRecords: 200,
      columns: [
        {
          field: 'type',
          label: 'Type',
          filterOptions: {
            enabled: false,
          },
          sortable: true,
        },
        {
          field: 'name',
          label: 'Naam',
          filterOptions: {
            enabled: false,
          },
          sortable: true,
        },
        {
          field: 'time',
          label: 'Tijd',
        },
      ],
      rows: [],
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },

        page: 1,
        perPage: 10,
      },
    }
  },
  computed: {

    filterColumns () {
      if (this.filters == null) {
        return 'col col-xs-12'
      }
      return `col col-xs-12 col-sm-${Math.max(3, Math.round(12 / this.filters.length))}`
    },

  },
  mounted () {
    this.filters = JSON.parse(this.filterOptions)
    this.setFilterOptions()
    if (this.startQuery !== '' && this.startQuery != null) {
      this.queryString = this.startQuery
      this.getResults()
    }
  },
  methods: {

    updateParams (newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },

    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },

    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },

    onSortChange (params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
      })
      this.loadItems()
    },

    onColumnFilter (params) {
      this.updateParams(params)
      this.loadItems()
    },

    // load items is what brings back the rows from server
    loadItems () {
      this.getResults()
      //        getFromServer(this.serverParams).then(response => {
      //          this.totalRecords = response.totalRecords;
      //          this.rows = response.rows;
      //        });
    },

    getResults () {
      // only peform search if there is a search query
      if (this.queryString) {
        this.loading = true
        let requestQueryParams = this.filterValues
        requestQueryParams.q = this.queryString
        this.highlightStrings = this.queryString.split(' ')
        requestQueryParams.program_id = this.programId
        // merges the search parameters and the parameters generated by VGT (vue good table)
        requestQueryParams = Object.assign(requestQueryParams, this.serverParams)

        axios.get('/employee/search/results', { params: requestQueryParams }).then(({ data }) => {
          this.rows = data.data.data

          this.totalRecords = data.data.totalRecords

          const allQueryString = qs.stringify(requestQueryParams, {
            arrayFormat: 'brackets',
            encode: false,
          })

          history.pushState(
            { data },
            'Search on ' + this.queryString,
            window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + allQueryString,
          )

          this.loading = false
        }).catch(error => defaultErrorMessage(error))
      }
    },

    setFilterOptions () {
      for (const i in this.filters) {
        for (const j in this.filters[i].values) {
          this.filterValues[this.filters[i].values[j].name] = this.filters[i].values[j].value
        }
      }
    },

    updateFilter (value) {
      Vue.set(this.filterValues, value.name, value.value)
    },

    format (value) {
      let display_string = this.ellipsis(value, this.highlightStrings[0])
      for (var i in this.highlightStrings) {
        const highlightString = this.highlightStrings[i]
        if (value.indexOf(highlightString) != -1) {
          display_string = this.ellipsis(value, highlightString)
          break
        }
      }

      // we add the tooltip last, since we do not want to highlight anthing in the tooltip
      // this might break down in some cases (where other html characters are used)
      for (var i in this.highlightStrings) {
        display_string = this.highlight(display_string, this.highlightStrings[i])
      }

      return display_string
    },

    tooltip (value, tooltip_value) {
      return '<span title="' + tooltip_value.replace('"', '&quot;') + '">' + value + '</span>'
    },

    ellipsis (value, center_on, max_length = 100) {
      // possible improvements to ellipsis functionality
      // - dont cut words
      // - always use 100 chars (now if we len(string) =400 and end=390 we only use 20 chars
      const old_length = value.length
      if (value.length > max_length) {
        // set the query position
        let queryPosition = value.indexOf(center_on)
        queryPosition = (queryPosition == -1 || queryPosition == 0) ? 10 : queryPosition
        const start = Math.max(queryPosition - 10, 0)
        const end = Math.min(value.length, queryPosition + 90)

        value = value.slice(start, end)

        // add ellipses
        if (start !== 0) {
          value = '(...)' + value
        }

        if (end !== old_length) {
          value = value + '(...)'
        }
      }

      return value
    },

    highlight (value, highlight_string) {
      // if a queryString exists, highlight the text
      if (highlight_string) {
        value = value.replace(new RegExp(escapeRegExp(highlight_string), 'gi'), match => {
          return '<span class="highlightText">' + match + '</span>'
        })
      }

      return value
    },
  },
}
</script>

<style scoped lang="scss">
    .search {
        display: inline-block;
        text-align: center
    }

    .search-field {
        width: 70%;
        height: 36px;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857143;
        color: #555555;
        background-color: #fff;
        background-image: none;
        border: 1px solid #ccc;
        border-radius: 2px;
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    }

    /deep/ .highlightText {
        background-color: yellow;
    }

    .chevron.right{
        border-left:6px solid #b71c1c;

    }

    .loading-data {
        width:100%;
        background-color:#23527c; color:white;
        padding:5px 0px;
    }

</style>
